import React, { Fragment, FunctionComponent, ReactElement } from "react";

export type LocalizationProviderComponentChildrenProps = {
    /** Lokalizovaný primární text */
    readonly text: string;
    /** Lokalizovaný sekundární text (popisek) */
    readonly title: string;
};

export type LocalizationProviderComponentProps = {
    /** Funkce jako potomek. Pokud není zadaná, komponenta zobrazí text. Pokud je zadaná, vytvoří obsah s možností využít text i popisek. */
    readonly children?: (props: LocalizationProviderComponentChildrenProps) => ReactElement;
} & LocalizationProviderComponentChildrenProps;

export const LocalizationProviderComponent: FunctionComponent<LocalizationProviderComponentProps> = ({ text, title, children }) => (
    children ? (
        children({ text, title })
    ) : (
        <Fragment>{ text }</Fragment>
    )
);
